import { render, staticRenderFns } from "./ReceiveForm.vue?vue&type=template&id=599e009f&scoped=true&"
import script from "./ReceiveForm.vue?vue&type=script&lang=js&"
export * from "./ReceiveForm.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveForm.vue?vue&type=style&index=0&id=599e009f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599e009f",
  null
  
)

export default component.exports